module.exports = __webpack_public_path__ + "static/media/_ME10908.0795c4cc.jpg";